import IFiltersTypeDescriptor from "./IFiltersDescriptor";

/**
 * Interface for board parameter type descriptors. These affect the behavior of the parameter card appearance on the Configurator.
 */
interface IBoardTypeDescriptor {
    editable?: boolean;
    readOnly?: boolean;
    tooltip?: string;
    format?: string;
    patternDirection?: boolean;
    filters?: IFiltersTypeDescriptor;
}

export default IBoardTypeDescriptor;
